<template>
  <div>
    <my-header v-if="$store.state.app.header.visible" v-model="$store.state.app.header"></my-header>

    <div v-if="contests.length">
      <contest-slider-mobile :contests="contests" v-if="$store.state.app.display ==='xs'"></contest-slider-mobile>
      <contest-slider :contests="contests" v-else></contest-slider>
    </div>

    <info-box :value="$store.state.app.info_box"></info-box>

    <search id="search"></search>

    <v-container style id="projects">
      <v-row justify="center">
        <v-col
          cols="11"
          sm="6"
          md="5"
          lg="4"
          xl="4"
          v-for="(project,i) in $store.state.projects.projects"
          :key="i"
        >
          <project-tile-mobile
            :project="project"
            v-if="$store.state.app.display ==='xs' || $store.state.app.display ==='sm'"
          ></project-tile-mobile>
          <project-tile v-else :project="project"></project-tile>
        </v-col>
        <template v-for="i in $store.getters['projects/batchSize']">
          <v-col
            cols="11"
            sm="6"
            md="5"
            lg="4"
            xl="4"
            v-if="$store.state.projects.loading"
            :key="'loader-'+i"
          >
            <v-sheet :color="``" class="px-3">
              <v-skeleton-loader class="mx-auto" type="card"></v-skeleton-loader>
            </v-sheet>
          </v-col>
        </template>
      </v-row>
    </v-container>

    <v-container
      v-intersect="onIntersect"
      style="margin-top:50px;margin-bottom:50px"
      v-if="!$store.state.projects.search"
    >
      <v-row>
        <v-col cols="12">
          <div
            class="text-center"
            v-if="$store.state.projects.limit_reached"
          >Stay tuned for more videos</div>
          <v-progress-linear :indeterminate="$store.state.projects.loading" v-else></v-progress-linear>
          <div
            class="text-center"
            v-if="!$store.state.projects.loading && !$store.state.projects.limit_reached"
          >
            <v-btn text @click="$store.dispatch('projects/load')">Load more</v-btn>
          </div>
        </v-col>
      </v-row>
    </v-container>

    <v-container
      style="margin-top:50px;margin-bottom:100px"
      v-if="$store.state.projects.search && !$store.state.projects.projects.length"
    >
      <v-row>
        <v-col cols="12">
          <div class="text-center">No results</div>
        </v-col>
      </v-row>
    </v-container>

    <footer-banner></footer-banner>
  </div>
</template>
<style media="screen">
#projects {
  max-width: 1024px;
}
</style>
<script>
//Components
import footerBanner from "@/components/app/footer-banner.vue";

import contestSlider from "@/components/contest/slider";
import contestSliderMobile from "@/components/contest/slider-mobile";

import search from "@/components/app/search";
import projectTileMobile from "@/components/project/tile-mobile";
import projectTile from "@/components/project/tile";

import header from "@/components/app/header.vue";
import infoBox from "@/components/app/info_box.vue";

export default {
  name: "home",
  metaInfo: {
    title: "WhyBuy - Genuine buying advice from passionate consumers",
    meta: [
      {
        name: "description",
        content:
          "We publish authentic consumer reviews and innovate new digital platforms that make sharing and creating quality videos easy.",
      },
      {
        name: "og:title",
        content: "WhyBuy - Genuine buying advice from passionate consumers",
      },
      {
        name: "og:description",
        content:
          "We publish authentic consumer reviews and innovate new digital platforms that make sharing and creating quality videos easy.",
      },
    ],
  },
  components: {
    contestSlider: contestSlider,
    contestSliderMobile: contestSliderMobile,
    search: search,
    projectTileMobile: projectTileMobile,
    projectTile: projectTile,
    footerBanner: footerBanner,
    myHeader: header,
    infoBox: infoBox,
  },
  data() {
    return {};
  },
  methods: {
    onIntersect(entries, observer, isIntersecting) {
      if (isIntersecting && this.$store.getters["projects/canLoad"]) {
        this.$store.dispatch("projects/load");
      }
    },
    goToSearch: function () {
      if (this.$route.name === "PublicProjects") {
        this.$store.commit("projects/show_search");
        setTimeout(
          function () {
            this.$vuetify.goTo("#search", {
              duration: 300,
              offset: 70,
              easing: "easeInOutCubic",
            });
          }.bind(this),
          100
        );
      } else {
        this.$router.push("/#search");
      }
    },
  },
  computed: {
    contests() {
      return this.$store.getters["contests/list"].filter((c) => {
        return c.status === 1;
      });
    },
  },
  async created() {
    this.$store.dispatch("contests/load");
    if (this.$route.hash === "#search") {
      setTimeout(
        function () {
          this.goToSearch();
        }.bind(this),
        200
      );
    }
    if (this.$route.query.search) {
      this.$store.commit("projects/update_search", this.$route.query.search);
      await this.$store.dispatch("projects/search");
    } else {
      if (!this.$store.state.projects.projects.length) {
        this.$store.dispatch("projects/search");
      }
    }
  },
  watch: {
    "$route.query": function () {
      if (this.$route.query.search) {
        this.goToSearch();
      }
    },
  },
};
</script>
